// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Hq_d","colMaxWidth":"Table_colMaxWidth__Q2DuS"};